import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, EventEmitter, Input, ViewChild } from '@angular/core';
import { find } from 'lodash';
import { Const } from '@app/shared';
import {
  Tarea,
  TaskEvent,
  Context,
  DynamicComponentForm,
  ConfigFinishDefault,
  TareaCondicion,
  Documento,
  ConfirmComponent
} from '@app/shared';

@Component({
  selector: 'iw-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.scss']
})
export class ApproveComponent extends DynamicComponentForm implements OnInit {
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<TaskEvent>;
  // tipo del proceso de la tarea renderizada
  typeProcess: string;
  // Tarea actual
  task: Tarea;
  // Determina si el usuario en sesion es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta finalizada
  finishTask = false;
  // Define si hay una secundaria iniciada
  secondaryActive = false;
  // id opcion del Sí
  idOptionAffirmative: number[] = [];
  // id opcion del No
  idOptionNegative: number[] = [];
  // Activa el btn de finalizar si hay una opción seleccionada
  isDisabledBtnFinish = true;
  // Diferentes opciones de aprovacion
  optionsPositive: Array<string> = [
    'sí', 'si'
  ];
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;

  constructor(private toastr: ToastrService) {
    super();
  }

  ngOnInit() {
    this.task = this.ctx.task;
    this.typeProcess = this.ctx.typeProcess;
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.finished
    ) {
      this.finishTask = true;
    }
    if (
      this.task &&
      this.task.tarea_estado &&
      this.task.tarea_estado.nombre === Const.STATUS_TASK.secondaryProgress
    ) {
      this.secondaryActive = true;
    }

    this.optionCondition();
    this.validReview();
  }

  /**
   * Actualiza la tarea en el json del flujo
   *
   * @param {*} data
   * @returns {*}
   * @memberof ApproveComponent
   */
  documentUpdate(data: Documento[]): any {
    for (let index = 0; index < this.ctx.task.tarea_asociacion.length; index++) {
      for (let indexDoc = 0; indexDoc < this.ctx.task.tarea_asociacion[index].documentos.length; indexDoc++) {
        const newDocument = find(
          data,
          {clasificacion_id: this.ctx.task.tarea_asociacion[index].documentos[indexDoc].clasificacion_id}
        );
        if (newDocument) {
          this.ctx.task.tarea_asociacion[index].documentos[indexDoc] = newDocument;
        }
      }
    }
    for (let index = 0; index < this.task.tarea_asociacion.length; index++) {
      for (let indexDoc = 0; indexDoc < this.task.tarea_asociacion[index].documentos.length; indexDoc++) {
        const newDocument = find(
          data,
          {clasificacion_id: this.task.tarea_asociacion[index].documentos[indexDoc].clasificacion_id}
        );
        if (newDocument) {
          this.task.tarea_asociacion[index].documentos[indexDoc] = newDocument;
        }
      }
    }
    this.updateTask(this.ctx.task);
    this.validReview();
  }

  /**
   * Finalizar la tarea.
   *
   * @param {boolean} res
   * @memberof ApproveComponent
   */
  finish(res: boolean) {
    const opcion = this.validapprovals();
    if (res) {
      const data: ConfigFinishDefault = {
        tarea: this.task.id,
        id_opciones: opcion
      };
      const e: TaskEvent = {
        type: 'finish',
        data: data
      };
      this.event.emit(e);
      this.close();
    }
  }

  /**
   * Define los id de las opciones de finalizacion
   *
   * @private
   * @memberof ApproveComponent
   */
  private optionCondition() {
    (<TareaCondicion[]>this.task.tarea_condicion).forEach(condition => {
      const existPositive = this.optionsPositive.indexOf(condition.opcion.toLowerCase());
      if (existPositive !== -1) {
        this.idOptionAffirmative.push(condition.id_opcion);
      } else {
        this.idOptionNegative.push(condition.id_opcion);
      }
    });
  }

  /**
   * Valida las revisiones para activar el boton de finalizar
   *
   * @private
   * @memberof ApproveComponent
   */
  private validReview() {
    let valid = false;
    const documents: Array<Documento> = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    for (let indexDocument = 0; indexDocument < documents.length; indexDocument++) {
      let required = false;
      documents[indexDocument].funciones.forEach(funcion => {
        if (
          funcion.funcion === Const.DOCUMENTS_FUNCTIONS.approve ||
          funcion.funcion === Const.DOCUMENTS_FUNCTIONS.sign
        ) {
          if (funcion.obligatorio) {
            required = true;
          }
        }
      });
      if (required) {
        for (let indexDetail = 0; indexDetail < documents[indexDocument].documentos_detalle.length; indexDetail++) {
          let indexMaxVersion = -1;
          let versionH = 0;
          for (
            let indexHistory = 0;
            indexHistory < documents[indexDocument].documentos_detalle[indexDetail].historial.length;
            indexHistory++
          ) {
            if (documents[indexDocument].documentos_detalle[indexDetail].historial[indexHistory].version > versionH) {
              versionH = documents[indexDocument].documentos_detalle[indexDetail].historial[indexHistory].version;
              indexMaxVersion = indexHistory;
            }
          }
          if (
            versionH &&
            documents[indexDocument].documentos_detalle[indexDetail].historial[indexMaxVersion].revision.length > 0
          ) {
            valid = true;
          } else {
            valid = false;
            break;
          }
          if (!valid) {
            break;
          }
        }
        if (!valid) {
          break;
        }
      } else {
        valid = true;
      }
    }
    if (valid) {
      this.isDisabledBtnFinish = false;
    } else {
      this.isDisabledBtnFinish = true;
    }
  }

  /**
   * Valida las revisiones de los documentos si estan con accion positiva o hay almenos un documento con una
   * accion negativa y retorna el id de la opcion correspondiente
   *
   * @private
   * @returns {number}
   * @memberof ApproveComponent
   */
  private validapprovals(): number[] {
    let disapprove = 0;
    const documents: Array<Documento> = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    documents.forEach(document => {
      document.documentos_detalle.forEach(detail => {
        const version = detail.historial.length;
        detail.historial.forEach(history => {
          if (history.version === version) {
            let idReview = 0;
            history.revision.forEach(review => {
              if (review.id_revision > idReview) {
                idReview = review.id_revision;
              }
            });
            history.revision.forEach(review => {
              if (review.id_revision === idReview) {
                if (!review.revision) {
                  disapprove += 1;
                }
              }
            });
          }
        });
      });
    });
    if (disapprove > 0) {
      return this.getOptionsFinish(false);
    } else {
      return this.getOptionsFinish(true);
    }
  }

  /**
   * Validad que la tarea se pueda finalizar
   *
   * @memberof ApproveComponent
   */
  finishConfirm() {
    if (!this.isDisabledBtnFinish && this.userResponsible && !this.finishTask && !this.secondaryActive) {
      this.confirmFinish.open();
    } else {
      if (!this.userResponsible) {
        this.toastr.error('Usted no posee los permisos suficientes para ejecutar esta acción.', 'Permiso denegado');
      } else if (this.finishTask) {
        this.toastr.error('La tarea ya está finalizada.', 'Acción no permitida');
      } else if (this.secondaryActive) {
        this.toastr.error(
          'No se puede realizar esta acción debido a que se encuentra un procesos secundario en progreso.',
          'Acción no permitida'
        );
      } else if (this.isDisabledBtnFinish) {
          this.toastr.error('Por Favor ingrese toda la información requerida.', 'Información incompleta');
      } else {
        this.toastr.error(
          'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde.',
          'Error inesperado'
        );
      }
    }
  }

  /**
   * Retorna las opciones de finalizacion de la tarea
   * vasado en las opciones de revisiones seleccionadas
   * a los diferentes documentos de la tarea
   *
   * @private
   * @param {boolean} approve
   * @memberof ApproveComponent
   */
  private getOptionsFinish(approve: boolean): number[] {
    const optionsFinish: number[] = [];
    const options = this.getOptionsSelect();
    if (options && options.length) {
      options.forEach(option => {
        let i = -1;
        if (approve) {
          i = this.idOptionAffirmative.indexOf(option);
        } else {
          i = this.idOptionNegative.indexOf(option);
        }
        if (i !== -1) {
          optionsFinish.push(option);
        }
      });
    }
    return optionsFinish;
  }

  /**
   * Retorna las opciones seleccionadas en las revisiones de los documentos
   *
   * @private
   * @memberof ApproveComponent
   */
  private getOptionsSelect(): number[] {
    const options: number[] = [];
    const documents: Documento[] = [];
    this.task.tarea_asociacion.forEach(taskAssociation => {
      taskAssociation.documentos.forEach(document => {
        documents.push(document);
      });
    });
    documents.forEach(document => {
      document.documentos_detalle.forEach(detail => {
        if (detail.historial && detail.historial.length) {
          detail.historial.sort((a, b) => b.version - a.version);
          if (detail.historial[0].revision.length) {
            const i = options.indexOf(detail.historial[0].revision[0].opcion);
            if (i === -1) {
              options.push(detail.historial[0].revision[0].opcion);
            }
          }
        }
      });
    });
    return options;
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/all/approve/approve.component.ts